export default {
  name: 'zh-cn',
  el: {},
}
